import * as React from 'react';
import { IDeleteIconProps } from '~/shared/types/types';


export const DeleteIcon: React.FC<IDeleteIconProps> = ({ size, handleClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
    width={size}
    height={size}
    onClick={handleClick}>
    <path
      d="M16.6 28.7h26.9v2.5H16.6z"
      style={{
        fill: '#c00',
      }}
      transform="rotate(-45 29.997 30.007)"
    />
    <path
      d="M28.7 16.6h2.5v26.9h-2.5z"
      style={{
        fill: '#c00',
      }}
      transform="rotate(-45 29.997 30.007)"
    />
    <path
      d="M30 56.3C15.5 56.3 3.7 44.5 3.7 30S15.5 3.7 30 3.7 56.3 15.5 56.3 30 44.5 56.3 30 56.3zm0-50C16.9 6.3 6.3 16.9 6.3 30S16.9 53.7 30 53.7 53.7 43.1 53.7 30 43.1 6.3 30 6.3z"
      style={{
        fill: '#c00',
      }}
    />
  </svg>
);
